// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2Tpb-","question":"Question_question__1IFD0","description":"Question_description__2jCBP"};